/** Helpers shared by the three catalog forms. Kept out of the component file
 * so fast refresh keeps working there. */

/** Drops one key from an error map — an error about a value the user has since changed is noise. */
export function without(source: Record<string, string>, key: string): Record<string, string> {
  const next = { ...source };
  delete next[key];
  return next;
}

/**
 * True when `value` is a real calendar date in 'YYYY-MM-DD' — mirrors the API's
 * own check so the user finds out before the round trip. Round-tripping through
 * UTC is what catches the impossible day: Date rolls 2025-02-30 forward to
 * 2025-03-02, so the parts stop matching.
 */
export function isRealDate(value: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const [year, month, day] = value.split('-').map(Number) as [number, number, number];
  const parsed = new Date(Date.UTC(year, month - 1, day));
  return (
    parsed.getUTCFullYear() === year &&
    parsed.getUTCMonth() === month - 1 &&
    parsed.getUTCDate() === day
  );
}
